<template>
  <div>
    <v-container>
      <div class="disable-favorites">
        <p>{{ moduleName }}</p>
        <v-row align="center">
          <v-col sm="2" xl="1">
            <v-select variant="underlined" :class="selectedYear ? 'selected' : ''" v-model="selectedYear" label="Год"
              :items="years"></v-select>
          </v-col>

          <v-col lg="8" xl="6" v-show="selectedYear">
            <v-file-input variant="underlined" accept=".zip,.pdf" chips multiple :label="'Разрешенные типы файлов: zip,pdf. Максимальный размер - ' + maxFileSize + 'Mb'
              " @update:modelValue="upload($event)"></v-file-input>
          </v-col>

          <v-col v-show="selectedYear">
            <log :target="'report_minobr\\' + reportType" class="inline pointer">
              <template #activator="{ props }">
                <v-icon color="primary" v-bind="props">
                  mdi-file-document
                </v-icon>
              </template>

              <template #data="{ log }">
                <v-card>
                  <v-card-text>
                    <div v-for="(task, index) in log" :key="index">
                      <div>
                        <div class="time">{{ task[0].timecreated }}</div>
                        <div v-for="(logRecord, index0) in task" :key="index0" class="message">
                          {{ logRecord.other.message }}
                        </div>
                      </div>
                      <v-divider v-if="index != log.length - 1" />
                    </div>
                  </v-card-text>
                </v-card>
              </template>
            </log>


            <v-icon color="success" class="pointer" @click="printExcel()" v-if="selectedYear && tableData">
              mdi-microsoft-excel
            </v-icon>


            <v-tooltip location="top" text="Полноэкранный режим">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" class="pointer" @click="selectedYear ? openFullscreen() : false">
                  mdi-fullscreen
                </v-icon>
              </template>
            </v-tooltip>
            <v-tooltip location="top" text="Парсинг файлов" v-if="$model.isAdmin && selectedYear && !disableRecalc">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" class="pointer" @click="selectedYear ? recalculate() : false">
                  mdi-content-save-alert
                </v-icon>
              </template>
            </v-tooltip>

            <v-tooltip location="top" text="Пересчет данных" v-if="$model.isAdmin && selectedYear && !disableRecalc">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" class="pointer" @click="selectedYear ? recalculate2() : false">
                  mdi-calculator
                </v-icon>
              </template>
            </v-tooltip>

          </v-col>
        </v-row>
        <v-row v-for="(progressKey, index) in progressKeys" :key="index">
          <v-col>
            <progress-helper :progressKey="progressKey" @finish="progressFinished" />
          </v-col>
        </v-row>
      </div>
    </v-container>
    <div v-if="tableData">

      <v-tabs v-model="tab" show-arrows="always">
        <v-tab v-for="(table, tableKey, tableIndex) in tableData" :key="tableKey">
          {{ tableHeaders[tableKey]["name"] }}
        </v-tab>
      </v-tabs>

      <v-window v-model="tab">
        <v-window-item v-for="(table, tableKey, tableIndex) in tableData" :key="tableKey">
          <v-card flat>
            <v-card-text>
              <v-data-table :id="'reportDataTable' + tableKey" :headers="tableHeaders[tableKey]['headers']"
                :items="table" class="elevation-1 nowrap reportDataTable" items-per-page="-1" fixed-header>
                <template v-slot:headers="{ columns, isSorted, getSortIcon, toggleSort }">
                  <tr>
                    <template v-for="head in columns" :key="head.key">
                      <th>
                        <v-tooltip location="top" :text="head.title" max-width="800">
                          <template v-slot:activator="{ props }">
                            <div v-bind="props" style="position: relative; cursor: pointer" class="hide-long-text"
                              @click="() => toggleSort(head)">
                              {{ head.title }}
                              <template v-if="isSorted(head)">
                                <v-icon style="position: absolute; top: 0; right: 0" :icon="getSortIcon(head)"></v-icon>
                              </template>
                            </div>
                          </template>
                        </v-tooltip>
                      </th>
                    </template>
                  </tr>
                </template>

                <template v-slot:item.name="{ item }">
                  <v-icon class="download" color="blue darken-2"
                    @click="downloadRawReport(item.id)">mdi-folder-download</v-icon>&nbsp;
                  {{ item.name }}
                </template>
                <template v-slot:bottom> </template>
              </v-data-table>

            </v-card-text>
          </v-card>
        </v-window-item>
      </v-window>

    </div>
  </div>
  <v-overlay v-model="overlay"></v-overlay>
</template>

<script>
import progressHelper from "moodleDir/procollege/lib/vue/ProgressHelper.vue";
import log from "moodleDir/procollege/lib/vue/log.vue";
export default {
  components: {
    progressHelper,
    log,
  },
  data() {
    return {
      years: [],
      selectedYear: null,
      progressKeys: [],
      tableHeaders: [],
      tableData: false,
      disableRecalc: true,
      overlay: false,
      moduleName: "",
      reportType: "",
      maxFileSize: 0,
      tab: null,
    };
  },
  created() {
    //by url. omelchenko|spo212, etc
    this.reportType = this.$route.fullPath.replace(/[^a-zA-Z0-9]/g, '');
    if (this.$model.modules[this.reportType] != undefined) {
      this.moduleName = this.$model.modules[this.reportType].componentName;
    }
    else {
      this.moduleName = "Ошибка. Не удалось найти название компонента"
    }


    this.axios
      .post(
        this.$model.wwwroot +
        "/procollege/report/minobr/" + this.reportType + "/getReportSettings",
        new URLSearchParams({
          reportType: this.reportType
        })
      )
      .then((response) => {
        this.years = response.data.years;
      })
      .catch((error) => {
        this.$eventBus.$emit("show-dialog", {
          title: "Ошибка",
          content: error.response.data,
        });
        console.log(error);
      }).finally(() => {
      });

    this.axios
      .post(
        this.$model.wwwroot +
        "/procollege/report/minobr/" + this.reportType + "/getUploadMaxFilesize",
      )
      .then((response) => {
        this.maxFileSize = response.data;
      })
      .catch((error) => {
        this.$eventBus.$emit("show-dialog", {
          title: "Ошибка",
          content: error.response.data,
        });
        console.log(error);
      }).finally(() => {
      });

    this.axios
      .post(
        this.$model.wwwroot +
        "/procollege/core_procollege/helpers/ProgressHelper/getAllTask",
        new URLSearchParams({
          page: document.location.pathname + document.location.hash,
        }),

      )
      .then((response) => {
        const contentType = response.headers['content-type'] || '';
        if (!contentType.includes('application/json')) {
          throw new Error('Обновите страницу');
        }

        if (typeof response.data == 'object') {
          this.progressKeys = response.data;
        }

      })
      .catch((error) => {
        this.$eventBus.$emit("show-dialog", {
          title: "Ошибка",
          content: error.response.data,
        });
        console.log(error);
      });
  },
  watch: {
    selectedYear: function (val) {
      if (val) {
        //не разрешаем пересчет за предыдущие годы
        if (this.years[this.years.length - 1] == val) {
          this.disableRecalc = false;
        }
        else {
          this.disableRecalc = true;
        }
        this.getReport();
      }
    },
  },
  methods: {
    upload(files) {
      if (files.length == 0) {
        return;
      }
      let formData = new FormData();

      for (let file of files) {
        formData.append("files[]", file, file.name);
      }
      formData.append("year", this.selectedYear);

      formData.append(
        "page",
        document.location.pathname + document.location.hash
      );

      formData.append(
        "reportType",
        this.reportType
      );
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/report/minobr/" + this.reportType + "/uploadReport",
          formData
        )
        .then((response) => {
          console.log("uploadReport")
          console.log(response.data)
          this.progressKeys.push(response.data);
        })
        .catch((error) => {
          this.$eventBus.$emit("show-dialog", {
            title: "Ошибка",
            content: error.response.data,
          });

          console.log(error);
        }).finally(() => {
        });
    },
    //парсинг pdf
    recalculate() {
      let formData = new FormData();
      this.disableRecalc = true;
      formData.append("year", this.selectedYear);
      formData.append(
        "page",
        document.location.pathname + document.location.hash
      );
      formData.append("reportType", this.reportType);

      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/report/minobr/" + this.reportType + "/reParse",
          formData
        )
        .then((response) => {
          this.disableRecalc = true;
          console.log("/recalculate")
          console.log(response.data)
          this.progressKeys.push(response.data);
        })
        .catch((error) => {
          this.disableRecalc = false;
          console.log(error);
        });
    },
    //удаление data, пересчет заново
    recalculate2() {
      let formData = new FormData();
      this.disableRecalc = true;
      formData.append("year", this.selectedYear);
      formData.append("reportType", this.reportType);

      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/report/minobr/" + this.reportType + "/recalculate",
          formData
        )
        .then((response) => {
          this.tableHeaders = response.data.headers;
          this.tableData = response.data.data;
          this.disableRecalc = false;
        })
        .catch((error) => {
          this.disableRecalc = false;
          console.log(error);
        });
    },
    downloadRawReport(id_org) {
      this.overlay = true;
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/report/minobr/" + this.reportType + "/downloadRawReport",
          new URLSearchParams({
            year: this.selectedYear,
            reportType: this.reportType
          }),
          {
            responseType: 'blob'
          }
        )
        .then((response) => {
          let link = document.createElement("a");
          link.href = URL.createObjectURL(response.data);

          let filename = "report.xlsx"
          if (typeof response.headers["content-disposition"] != "undefined") {
            let t = response.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (t && t[1] && t[1] != "undefined") {
              filename = decodeURIComponent(t[1]);
              filename = filename.replace(/[\"\'\\]/g, '')
            }
          }

          link.download = filename;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href)
          document.body.removeChild(link);
        })
        .catch(() => {
          this.$eventBus.$emit("show-dialog", {
            title: "Ошибка",
            content: 'file not found'
          });
        }).finally(() => {
          this.overlay = false;
        });
    },
    getReport() {
      this.overlay = true;
      this.disableRecalc = true;
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/" + this.reportType + "/getReport",
          new URLSearchParams({
            year: this.selectedYear,
            reportType: this.reportType
          })
        )
        .then((response) => {
          this.tableHeaders = response.data.headers;
          this.tableData = response.data.data;

          this.disableRecalc = false;
        })
        .catch((error) => {
          this.disableRecalc = false;
          this.$eventBus.$emit("show-dialog", {
            title: "Ошибка",
            content: error.response.data,
          });
          console.log(error);
        }).finally(() => {
          this.overlay = false;
        });
    },
    printExcel() {
      this.overlay = true;
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/report/minobr/" + this.reportType + "/printExcel",
          new URLSearchParams({
            reportType: this.reportType,
            year: this.selectedYear
          }),
          {
            responseType: 'blob'
          }
        )
        .then((response) => {
          let link = document.createElement("a");
          link.href = URL.createObjectURL(response.data);

          let filename = "report.xlsx"
          if (typeof response.headers["content-disposition"] != "undefined") {
            let t = response.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (t && t[1] && t[1] != "undefined") {
              filename = decodeURIComponent(t[1]);
              filename = filename.replace(/[\"\'\\]/g, '')
            }
          }

          link.download = filename;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href)
          document.body.removeChild(link);
        })
        .catch((error) => {
          this.$eventBus.$emit("show-dialog", {
            title: "Ошибка",
            content: error.response.data,
          });
          console.log(error);
          console.log(error);
        }).finally(() => {
          this.overlay = false;
        });
    },
    openFullscreen() {
      let tableKey = Object.keys(this.tableData)[this.tab];
      var elem = document.getElementById("reportDataTable" + tableKey)

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen();
      }
    },
    progressFinished(key) {
      this.getReport();
      //TODO только 1 процесс завершился. Может есть еще другие?
      this.disableRecalc = false;

      var index = this.progressKeys.indexOf(key);
      if (index !== -1) {
        this.progressKeys.splice(index, 1);
      }
    },
  },
};
</script>
<style>
.reportDataTable tbody>tr>td:first-child,
.reportDataTable thead>tr>th:first-child {
  position: sticky !important;
  left: 0;
  z-index: 1;
  background-color: white;
}
</style>
<style scoped>
.download {
  cursor: pointer;
}

.selected:v-deep div.v-select__slot {
  height: 40px;
}

.time {
  font-size: 10pt;
  color: #000;
  opacity: 0.5;
}

.message {
  font-size: 12pt;
  color: darkslateblue;
  border: none;
}

.inline {
  display: inline;
}

.pointer {
  cursor: pointer;
}

#reportDataTable {
  overflow-y: scroll;
}

.hide-long-text {
  max-height: 150px;
  overflow: hidden;
}
</style>
